import { render, staticRenderFns } from "./noMemberList.vue?vue&type=template&id=4d244980&scoped=true&"
import script from "./noMemberList.vue?vue&type=script&lang=js&"
export * from "./noMemberList.vue?vue&type=script&lang=js&"
import style0 from "./noMemberList.vue?vue&type=style&index=0&id=4d244980&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d244980",
  null
  
)

export default component.exports